/**
 * App copy not in design/i18n/en.json yet (none at the moment). Same rules as en.json; design adds the keys, then
 * they leave this file (`pending.test.ts` fails while a key is in both). Pending keys are English in every locale
 * until then (they are not in the translations).
 */
export const pendingCopy = {} as const;
